import API from '../.';

const me = () => API.get('/api/v1/me/');

export default me;
